import Dexie, { type EntityTable } from "dexie";
import type { AudioRecord, LibrarySettings, Playlist, Track } from "./model";

class LibraryDatabase extends Dexie {
  tracks!: EntityTable<Track, "id">;
  audio!: EntityTable<AudioRecord, "trackId">;
  playlists!: EntityTable<Playlist, "id">;
  settings!: EntityTable<LibrarySettings, "id">;

  constructor() {
    super("needle-drop-library");
    this.version(1).stores({
      tracks: "id, title, artist, album, label, year, rating, favorite, addedAt, fileHash, *genres, *tags, *categories",
      audio: "trackId",
      playlists: "id, name, type, updatedAt, *trackIds",
      settings: "id",
    });
  }
}

export const db = new LibraryDatabase();
